import { useUserOptional } from '@/providers/UserProvider';

/**
 * Answer Assist feature-family gates. Hub controls these per tenant via
 * /api/v1/admin/features; /users/me delivers the map. Absent or off means the
 * form renders exactly as it does today.
 */
export const useAssistFeatures = () => {
  const context = useUserOptional();
  const features = context?.userData?.features ?? {};

  return {
    answerAssist: features.answer_assist === true,
    verifyAnswer: features.verify_answer === true,
    publicCollections: features.public_collections === true,
  };
};
